// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Divider } from '@mui/material';
import { Holding } from '@daml.js/utility-registry-holding-v0/lib/Utility/Registry/Holding/V0/Holding';
import TemplateContract from '../utils/TemplateContract';
import { values } from '../utils/common';
import { DetailsRow } from './DetailsRow';
import PartyDisplay from './PartyDisplay';
import { DetailsLayout } from './Table/DetailsLayout';

interface HoldingDetailProps {
  row?: TemplateContract<Holding>;
}
export const HoldingDetail: React.FC<HoldingDetailProps> = ({ row }) => {
  if (!row) {
    return null;
  }
  const details = [
    {
      label: 'holder',
      value: row.payload.owner,
    },
    {
      label: 'registrar',
      value: row.payload.registrar,
    },
    {
      label: 'Operator',
      value: row.payload.operator,
    },
    {
      label: 'label',
      value: row.payload.label,
    },
    {
      label: 'Lock',
      value: row.payload.lock
        ? values(row.payload.lock.lockers).map((party) => (
            <PartyDisplay key={uuidv4()} party={party} />
          ))
        : null,
    },
    {
      label: 'lock context',
      value: row.payload.lock ? row.payload.lock.context : '',
    },
  ];

  return (
    <DetailsLayout>
      <DetailsRow label="Instrument Id" value={row.payload.instrument.id} />
      <DetailsRow label="amount" value={row.payload.amount} isNumber />
      <Divider sx={{ mt: 1, mb: 1 }} />
      {details.map((detail) => (
        <DetailsRow key={detail.label} value={detail.value} label={detail.label} />
      ))}
    </DetailsLayout>
  );
};
